// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SGMP","content":"styles_content__3m-Mk","tableWrap":"styles_tableWrap__2J2wY"};